/**
 * Private column-equality row filters for V1 state.
 * Not exported from package index — no matchmaking semantics.
 */

/**
 * @param {object[]} rows
 * @param {Record<string, unknown>} criteria — only own enumerable keys; equality match
 * @returns {object[]}
 */
export function filterRowsByColumns(rows, criteria) {
  if (!Array.isArray(rows) || !criteria || typeof criteria !== 'object') {
    return [];
  }
  const keys = Object.keys(criteria);
  if (keys.length === 0) return rows.slice();
  return rows.filter((row) =>
    keys.every((key) => row[key] === criteria[key]),
  );
}

/**
 * @param {object[]} rows
 * @param {string} column
 * @param {unknown} value
 * @returns {object[]}
 */
export function filterRowsByColumn(rows, column, value) {
  return filterRowsByColumns(rows, { [column]: value });
}
